import { setActiveAction} from '@process-advisor/process-miner/processMiner/processMiner'
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {}

export const setAction_Cluster = ({ eventEmitter }: Props) => {
    setActiveAction('cluster_insights')
    eventEmitter.emit(Event.setActionBar_Cluster, { findingID: null, source: 'cluster_insights' });
    eventEmitter.emit(Event.setDiagramWidth, { findingID: null });
};
